export const GET_PRODUCT_PAGE_START = 'GET_PRODUCT_PAGE_START';
export const GET_PRODUCT_PAGE_SUCCESS = 'GET_PRODUCT_PAGE_SUCCESS';
export const GET_PRODUCT_PAGE_ERROR = 'GET_PRODUCT_PAGE_ERROR';

export const getProductPage = (testCode, language) => ({
  type: GET_PRODUCT_PAGE_START,
  payload: {
    testCode,
    language,
  },
});
